module.exports = __webpack_public_path__ + "static/media/valor1.b4de055a.png";